import React from "react";

const Java_Array = () => {
  return (
    <div>
      <h1>Java Array</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Array in Java.</p>
    </div>
  );
};

export default Java_Array;
